import { render, staticRenderFns } from "./SocialBanner.vue?vue&type=template&id=741fe350&scoped=true&"
import script from "./SocialBanner.vue?vue&type=script&lang=js&"
export * from "./SocialBanner.vue?vue&type=script&lang=js&"
import style0 from "./SocialBanner.vue?vue&type=style&index=0&id=741fe350&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741fe350",
  null
  
)

export default component.exports